import React from 'react';
import ColorsMain from '../../colors/ColorsMain';

const ButtonHomeWallet = ({ imageSrc, balance, balanceConvert, title, onClick, loading }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full h-full bg-[${ColorsMain.bgLayout}] rounded-[12px] text-[${ColorsMain.texttMain}] 
        flex flex-col justify-between  transition-transform duration-500 
        outline-none `}
    >
      {/* Header */}
      <div>

        <div className="flex items-center gap-2 p-4">
          {loading ? (
            <div className="w-4 h-4 bg-gray-700 rounded-full animate-pulse"></div>
          ) : (
            imageSrc && <img src={imageSrc} alt="imagen cripto" className="w-4 h-4" />
          )}
          <span className={`text-[16px] font-bold leading-5 tracking-[-0.16px] text-[${ColorsMain.bgLogin}]`}>
            {loading ? <div className="h-4 w-16 bg-gray-700 rounded animate-pulse"></div> : title}
          </span>
        </div>
        <div className="w-full h-[1px] bg-[#141319]"></div>
      </div>

      {/* Divider */}

      {/* Cuerpo del botón */}
      <div className="p-4 flex flex-col items-end w-full">
        {loading ? (
          <>
            <div className="h-6 w-20 bg-gray-700 rounded animate-pulse mb-2"></div>
            <div className="h-4 w-14 bg-gray-700 rounded animate-pulse"></div>
          </>
        ) : (
          <>
            <p className="text-[22px] leading-7 tracking-tighter font-normal">
              {balance === '0.00' ? '$ 0.00' : balance}
            </p>
            <p className="text-sm text-[#8A8A8E] font-normal leading-[18.2px] tracking-[-0.14px]">
              {/*               {balanceConvert}
 */}            </p>
          </>
        )}
      </div>
    </button>
  );
};

export default ButtonHomeWallet;
